import React, { Component } from 'react'
import styles from './index.module.less'
import classnames from 'classnames'

import PullToRefresh from 'antd-mobile/lib/pull-to-refresh'
import context from '../../context'
import { getReferralHistory, inviteRecordStatistics } from '@/components/poizon-fission/apis'

interface IState {
  pageNum: number
  isFinish: boolean
  list: any
  inviteUsers: number
  inviteSettledUsers: number
}

class Referral extends Component<unknown, IState> {
  static contextType = context
  refreshing: boolean
  constructor(props) {
    super(props)
    this.state = {
      pageNum: 1,
      isFinish: false,
      list: [],
      inviteUsers: 0,
      inviteSettledUsers: 0,
    }
    this.refreshing = false
    this.load = this.load.bind(this)
  }

  componentDidMount() {
    this.load()
    this.loadInviteRecordStatistics()
  }

  async load() {
    this.refreshing = true
    const { pageNum, isFinish, list } = this.state
    if (isFinish) {
      return
    }
    const { lang, local, activityType } = this.context
    const { code, data } = await getReferralHistory({
      pageNum: pageNum,
      pageSize: 10,
      countryCode: local,
      language: lang,
      activityType,
    })

    this.refreshing = false
    if (code !== 200) {
      return
    }
    const nextPageNum = this.state.pageNum + 1
    this.setState({
      pageNum: nextPageNum,
      isFinish: nextPageNum > data?.pages,
      list: data?.contents ? list.concat(data.contents) : list,
      inviteUsers: data.total,
    })
  }
  async loadInviteRecordStatistics() {
    const { lang, local, activityType } = this.context
    const { code, data } = await inviteRecordStatistics({
      countryCode: local,
      language: lang,
      activityType,
    })
    if (code !== 200) {
      return
    }
    this.setState({
      ...data,
    })
  }

  render() {
    const { referralHistory } = this.context
    const { inviteUsers, inviteSettledUsers, list } = this.state
    const show = list && list.length

    return (
      <div className={styles.referral}>
        <div className={styles.header}>
          <span>
            {referralHistory.col1}：{inviteUsers}
          </span>
          <span>
            {referralHistory.col2}：{inviteSettledUsers}
          </span>
        </div>
        <div className={classnames(styles.list, { [styles.hidden]: !show })}>
          <PullToRefresh
            style={{
              height: 220,
              overflow: 'auto',
            }}
            getScrollContainer={() => ''}
            damping={60}
            distanceToRefresh={20}
            indicator={{
              activate: ' ',
              deactivate: ' ',
              finish: ' ',
            }}
            direction="up"
            refreshing={this.refreshing}
            onRefresh={this.load}
          >
            {list.map(({ inviteHeadImg, inviteName, inviteTime }) => (
              <div key={inviteTime} className={styles.item}>
                <div className={styles.info}>
                  <em
                    style={{
                      backgroundImage: `url(${
                        inviteHeadImg ||
                        'https://cdn.poizon.com/node-common/edbc42094d8eba30d1a6985f96a01a0e.png'
                      })`,
                    }}
                  />
                  <span>{inviteName}</span>
                </div>
                <span className={styles.date}>{inviteTime}</span>
              </div>
            ))}
          </PullToRefresh>
        </div>
        <div className={classnames(styles.empty, { [styles.hidden]: show })}>
          {referralHistory.empty}
        </div>
      </div>
    )
  }
}

export default Referral
